var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 52 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0501 3.65015H18.7843V28.5499H34.0501V3.65015Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3245 16.1C20.325 13.7047 20.8674 11.3404 21.9111 9.18441C22.9548 7.02838 24.4728 5.1364 26.3513 3.65014C24.0151 1.81332 21.2092 0.670884 18.2544 0.353438C15.2996 0.0359914 12.315 0.556341 9.64196 1.85501C6.9689 3.15367 4.71517 5.17824 3.1384 7.69729C1.56164 10.2163 0.725464 13.1282 0.725464 16.1C0.725464 19.0719 1.56164 21.9838 3.1384 24.5028C4.71517 27.0218 6.9689 29.0464 9.64196 30.3451C12.315 31.6438 15.2996 32.1641 18.2544 31.8467C21.2092 31.5292 24.0151 30.3868 26.3513 28.5499C24.4728 27.0637 22.9548 25.1717 21.9111 23.0157C20.8674 20.8596 20.325 18.4954 20.3245 16.1V16.1Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 16.1001C52.0021 19.0698 51.1684 21.9801 49.5942 24.4982C48.0201 27.0163 45.7689 29.0406 43.0984 30.3394C40.4278 31.6382 37.4456 32.1592 34.4928 31.8428C31.54 31.5263 28.736 30.3852 26.4012 28.55C28.2802 27.0641 29.7985 25.1722 30.8423 23.0161C31.8861 20.86 32.4283 18.4956 32.4283 16.1001C32.4283 13.7046 31.8861 11.3402 30.8423 9.18408C29.7985 7.02796 28.2802 5.13606 26.4012 3.65019C28.736 1.81495 31.54 0.673861 34.4928 0.35742C37.4456 0.0409797 40.4278 0.561969 43.0984 1.8608C45.7689 3.15963 48.0201 5.18387 49.5942 7.70198C51.1684 10.2201 52.0021 13.1304 52 16.1001V16.1001Z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.d7d8816375273f861a95a146707eeb4a.svg";
export { ForwardRef as ReactComponent };